import CheckoutSessionModel from '../../../models/stripe/CheckoutSession';
import HttpReference from '../../platform/HttpReference';
import Checkout from './Checkout';

export default class CheckoutSessions extends HttpReference<CheckoutSessionModel, void, Checkout> {
  async create(vendorId: string) {
    return this.request({method: 'POST', data: {vendorId}});
  }
}
